import React from 'react';
import DatePicker from 'react-datepicker';
import { Search, Calendar, User } from 'lucide-react';
import { DailySearchForm as DailySearchFormType } from '../types';
import { parseLocalDate } from '../utils';
import 'react-datepicker/dist/react-datepicker.css';

type DailySearchFormProps = {
  form: DailySearchFormType;
  errors: Partial<DailySearchFormType>;
  isLoading: boolean;
  onUserIdChange: (value: string) => void;
  onSelectedDateChange: (date: Date | null) => void;
  onSearch: () => void;
};

export const DailySearchForm: React.FC<DailySearchFormProps> = ({
  form,
  errors,
  isLoading,
  onUserIdChange,
  onSelectedDateChange,
  onSearch,
}) => {
  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">指定日を表示</h2>
      
      <div className="space-y-4">
        {/* ユーザID入力 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <User className="inline w-4 h-4 mr-2" />
            ユーザID
          </label>
          <input
            type="text"
            value={form.userId}
            onChange={(e) => onUserIdChange(e.target.value)}
            placeholder="例: 506"
            className={`input-field ${errors.userId ? 'border-red-500' : ''}`}
          />
          {errors.userId && (
            <p className="mt-1 text-sm text-red-600">{errors.userId}</p>
          )}
        </div>

        {/* 計測日選択 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar className="inline w-4 h-4 mr-2" />
            計測日
          </label>
          <DatePicker
            selected={parseLocalDate(form.selectedDate)}
            onChange={onSelectedDateChange}
            dateFormat="yyyy-MM-dd"
            placeholderText="YYYY-MM-DD"
            className={`input-field ${errors.selectedDate ? 'border-red-500' : ''}`}
            maxDate={new Date()}
          />
          {errors.selectedDate && (
            <p className="mt-1 text-sm text-red-600">{errors.selectedDate}</p>
          )}
        </div>

        {/* 日別検索ボタン */}
        <button
          onClick={onSearch}
          disabled={isLoading}
          className={`w-full btn-primary flex items-center justify-center ${
            isLoading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          <Search className="w-4 h-4 mr-2" />
          {isLoading ? '検索中...' : '日別検索'}
        </button>
      </div>
    </div>
  );
};
